import { Validators } from '@angular/forms';

export const EIGHT_DIGITS_PATTERN_VALIDATOR = Validators.pattern(/^(?!0?(\.0{1,2})?$)([1-9][0-9]{0,7}|0)(\.[0-9]{1,2})?$/);
export const EIGHT_DIGITS_ALLOW_ZERO_PATTERN_VALIDATOR = Validators.pattern(/^(0|[1-9][0-9]{0,7})(\.[0-9]{1,2})?$/);
export const SIX_DIGITS_PATTERN_VALIDATOR = Validators.pattern(/^(?!0?(\.0{1,2})?$)([1-9][0-9]{0,5}|0)(\.[0-9]{1,2})?$/);
export const NUMERIC_PATTERN_VALIDATOR = Validators.pattern(/^[0-9]+$/);
export const UNLOCODE_PATTERN_VALIDATOR = Validators.pattern(/^[A-Za-z]{2}[A-Za-z0-9]{3}$/);
